import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MessageModel } from '@models/message.model';
import { TableConductorService } from '@services/admin/table-conductor.service';
import { ActionModel } from '@models/admin/action.model';
import { CompareService } from '@services/admin/compare.service';

@Injectable({
  providedIn: 'root',
})
export class MessageHandlerService {
  private readonly messageService = inject(MessageService);
  private readonly compareService = inject(CompareService);
  private readonly tableConductorService = inject(TableConductorService);

  handle(message: MessageModel) {
    let actions = message.actions;
    let messageActions = [];

    actions?.forEach(action => {
      if (action.actionType === 'tableUpdate')
        this.tableConductorService.updateTable(action.name);
      else
        messageActions.push(action);
    });

    message.actions = this.filterActions(messageActions);

    this.addMessage(message);
  }

  private filterActions(actions: ActionModel[]) {
    return actions.filter(action => !this.compareService.checkForMessageAction(action, 'hide'));
  }

  private addMessage(message: MessageModel) {
    if (message.message || message.title || message.actions?.length)
      this.messageService.add({
        severity: message.type,
        summary: message.title,
        detail: message.message,
        data: message.actions,
        life: message.life * 1000,
        closable: true,
      });
  }
}
